<template>
  <div>
      <div class="canvas">
          <b-upload v-if="!dropFile" @input="loadImage" v-model="dropFile"
            drag-drop>
            <section class="section">
                <div class="content has-text-centered">
                    <p>
                        <b-icon
                            icon="upload"
                            size="is-large">
                        </b-icon>
                    </p>
                    <p>Drop your image here or click to upload</p>
                </div>
            </section>
        </b-upload>
        <div v-if="dropFile" class="croppyContainer">
            <div ref="cropper"></div>
        </div>
      </div>
        <b-button type="is-primary" v-if="dropFile" @click="getCropp">Save</b-button>
        <b-button v-if="dropFile" @click="reset">Try other</b-button>
  </div>
</template>

<script>
import Croppie from 'croppie'
export default {
    name:"ImageUploader",
    props:{
    },
    data(){
        return{
            ImageUploader:{},
            cropper:null,
            dropFile:null,
            result:null
        }
    },
    methods:{
        loadImage(){
            var fr = new FileReader();

            fr.onload =  ()=> {
                if(!this.cropper) this.mountCropper() 
                this.setImageToCrop(fr.result);
              
            }
            fr.readAsDataURL(this.dropFile);
        },
        setImageToCrop(imageFile){
            this.cropper.bind({
                url:imageFile
            })
        },
        mountCropper(){
            var el = this.$refs.cropper
            this.cropper = new Croppie(el,{
                viewport: {
                    width: 250,
                    height: 250,
                }
            })
        },
        getCropp(){
            this.cropper.result('blob').then((blobResult)=>{
                var urlCreator = window.URL || window.webkitURL;
                
                var myfile = new File([blobResult], this.dropFile.name,new Date());
                this.$emit("input",{
                    localUrl:urlCreator.createObjectURL(blobResult),
                    file:myfile
                    })
            })
        },
        reset(){
            this.result = null
            this.dropFile = null
            this.cropper.destroy()
            this.cropper = null
        }
    }
}
</script>

<style>
@import url("https://unpkg.com/croppie/croppie.css");
.croppyContainer{
    justify-items: center;
    width: 100%;
    height: 100%;
}
.canvas{
    width: 300px;
    height: 300px;
    margin: auto;
    margin-bottom: 40px;
}
</style>